/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceStandardListRequest {
    getFixupPrototypeFunction() { return ComplianceStandardListRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceStandardListRequest>): ComplianceStandardListRequest {
        let obj = Object.assign(new ComplianceStandardListRequest(), model);
        ComplianceStandardListRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceStandardListRequest>): ComplianceStandardListRequest {
        if (!model) return null;
        return ComplianceStandardListRequest.newInstance(<ComplianceStandardListRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceStandardListRequest) {
        if (!obj) return;

        models.ComplianceStandardListRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceStandardListRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceStandardListRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.list_context) {
            models.ListContext.fixupPrototype(this.list_context);
        }
        if (this.filters) {
            models.ComplianceStandardFilter.fixupPrototype(this.filters);
        }
        if (this.sort) {
            for (let val of this.sort) {
                models.ComplianceStandardSortCriteria.fixupPrototype(val);
            }
        }
    }

    /**
     * Optional list context
     */
    list_context: models.ListContext;

    /**
     * Sort criteria
     */
    sort: Array<models.ComplianceStandardSortCriteria>;

    /**
     * Filters for the request
     */
    filters: models.ComplianceStandardFilter;

}
